<template>
  <div>
    <span class="unit">{{ value.unitName }}</span>
    <span class="unit-change" @click="dialogFormVisible = true">更换</span>
    <el-dialog
      title="选择计量单位"
      :visible.sync="dialogFormVisible"
      class="metering-dialog"
      :before-close="() => (dialogFormVisible = false)"
      width="650px"
      height="auto"
    >
      <el-form ref="unitForm" :model="valueInner" label-width="126px">
        <el-form-item label="单位转换设置：">
          <el-input v-model="valueInner.basicUnitName" disabled />
          <i class="dialog-icon icon-ccui-switch" />
          <el-select
            filterable
            v-model="unitObj"
            value-key="dicKey"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in valueInner.units"
              :key="index"
              :label="item.dicValue"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单位转换比例设置：">
          <el-input
            v-model="valueInner.basicRate"
            maxlength="20"
            @keyup.native="handleInput"
          >
            <template slot="append">{{ valueInner.basicUnitName }}</template>
          </el-input>
          <span class="dialog-span">=</span>
          <el-input
            maxlength="20"
            v-model="valueInner.converRate"
            placeholder="请输入"
            clearable
            @keyup.native="handleInput"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <span class="tips">*输入比例必须为正整数</span>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="changeUnit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "chooseUnit",
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogFormVisible: false,
      valueInner: {},
      unitObj: {
        dicKey: "",
        dicValue: ""
      }
    };
  },

  components: {},

  computed: {},

  watch: {
    unitObj({ dicKey, dicValue }) {
      this.valueInner = {
        ...this.valueInner,
        unitCode: dicKey,
        unitName: dicValue
      };
    }
  },

  beforeMount() {},

  mounted() {
    const { unitCode, unitName } = this.value;
    this.unitObj = {
      dicValue: unitName,
      dicKey: unitCode
    };
    this.valueInner = { ...this.value };
  },

  methods: {
    changeUnit() {
      this.$refs["unitForm"].validate(valid => {
        if (valid) {
          this.dialogFormVisible = false;
          console.log("🚀 ~ this.$refs", this.valueInner);
          this.$emit("update:value", this.valueInner);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleInput() {
      this.$set(
        this.valueInner,
        "basicRate",
        this.valueInner.basicRate.replace(/[^\d.]/g, "")
      );
      this.$set(
        this.valueInner,
        "basicRate",
        this.valueInner.basicRate.replace(".", "")
      );
      this.$set(
        this.valueInner,
        "converRate",
        this.valueInner.converRate.replace(/[^\d.]/g, "")
      );
      this.$set(
        this.valueInner,
        "converRate",
        this.valueInner.converRate.replace(".", "")
      );
    },
    inputConverRate(value) {
      let reg = /^(\d{0,100})(\.(\d{0,2}))?$/g;
      let newVal = this.valueInner.converRate;
      if (!reg.test(newVal)) {
        this.valueInner.converRate = this.valueInner.converRate.substring(
          0,
          this.valueInner.converRate.length - 1
        );
        this.valueInner.converRate = this.valueInner.converRate.replace(
          /[^\d.]/g,
          ""
        );
      } else {
        this.valueInner.converRate = this.valueInner.converRate;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.unit {
  color: #4a4a4a;
}
.unit-change {
  color: #0089ef;
  margin-left: 10px;
  cursor: pointer;
}
/deep/ .unitForm {
  &:after {
    content: "";
    display: table;
    clear: both;
  }
}
/deep/ .unit-form-item {
  width: 43%;
  float: left;
  &.first-rate {
    .el-form-item__error {
      left: 50px;
    }
  }
}
.metering-dialog {
  .el-input,
  .el-select {
    width: 160px;
  }

  .dialog-icon {
    margin: 0 20px;
  }

  .dialog-span {
    margin: 0 23px;
  }
}
.tips {
  // color: $--breadcrumb-separator-color;
  font-size: 11px;
  margin-right: 350px;
  color: #ff142f;
}
.dialog-footer {
  .el-button {
    padding: 0 15px !important;
  }
}
</style>
